import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useFulfillList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [fulfillList, setFulfillList] = useState([]);
  const [fulfillmentConfig, setFulfillmentConfig] = useState([]);
  const [fulfillmentCount, setFulfillmentCount] = useState({
    totalNum: 0,
    connectedNum: 0,
    expireNum: 0,
    disconnectedNum: 0,
    restrictedNumber: 0
  });
  const fetchData = async (status) => {
    try {
      setIsLoading(true);
      if (status === "RESTRICTED") {
        setFulfillList([]);
        return {fulfillList: []};
      }
      const {data} = await axios.post(`/saas/fulfillment-authorization/getAuthorizationList`, {
        status: status === "ALL" ? void 0 : status
      });
      setFulfillList(data);
      return {fulfillList: data};
    } catch (error) {
      handleError(error);
      return {fulfillList: []};
    } finally {
      setIsLoading(false);
    }
  };
  const fetchFulfillmentConfig = async (operationType, fulfillment, id, params) => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`/saas/fulfillment-configuration/list`, {
        fulfillment,
        externalMerchantId: id,
        operationType,
        ...params
      });
      setFulfillmentConfig(data);
      return {fulfillmentConfig: data};
    } catch (error) {
      handleError(error);
      return {fulfillmentConfig: []};
    } finally {
      setIsLoading(false);
    }
  };
  const fetchFulfillmentCount = async () => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`/saas/fulfillment-authorization/getAuthorizationCount`);
      setFulfillmentCount(data);
      return {fulfillmentCount: data};
    } catch (error) {
      handleError(error);
      return {
        fulfillmentCount: {
          totalNum: 0,
          connectedNum: 0,
          expireNum: 0,
          disconnectedNum: 0
        }
      };
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    fulfillList,
    fetchFulfillmentConfig,
    fulfillmentConfig,
    fetchFulfillmentCount,
    fulfillmentCount
  };
};
export const useFulfillModel = createModel(useFulfillList);
